import type { Config } from '@utils/config.svelte'

type RestrictedModelConfig = Pick<Config, 'restrictedModelIds'> | null | undefined

const getRestrictedModelIds = (config: RestrictedModelConfig): string[] =>
  config?.restrictedModelIds ?? []

const getRestrictedModelConfig = (config: RestrictedModelConfig) => {
  const restrictedModelIds = getRestrictedModelIds(config)
  return {
    restrictedModelIds,
    isRestrictedMode: restrictedModelIds.length > 0,
  }
}

const getModelSourceName = (modelSource: unknown): string | null => {
  if (!modelSource || typeof modelSource !== 'object') {
    return null
  }
  const { modelName } = modelSource as { modelName?: unknown }
  return typeof modelName === 'string' ? modelName : null
}

const isModelSourceApprovedForUnlearning = (modelSource: unknown, restrictedModelIds: string[]) => {
  if (restrictedModelIds.length === 0) {
    return true
  }
  const modelName = getModelSourceName(modelSource)
  return modelName !== null && restrictedModelIds.includes(modelName)
}

export { getModelSourceName, getRestrictedModelConfig, isModelSourceApprovedForUnlearning }
